// extracted by mini-css-extract-plugin
export var modal = "_4x-0";